/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcErrorHexagonRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path d="M12 6.25c-.678 0-1.216.571-1.176 1.248l.293 4.92a.884.884 0 0 0 1.766 0l.293-4.92A1.18 1.18 0 0 0 12 6.25m0 8.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3" />
      <path
        fillRule="evenodd"
        d="M16.095 2.44h-8.19a2.9 2.9 0 0 0-2.512 1.45l-4.095 7.093a2.9 2.9 0 0 0 0 2.9l4.095 7.094a2.9 2.9 0 0 0 2.512 1.45h8.19a2.9 2.9 0 0 0 2.512-1.45l4.095-7.094a2.9 2.9 0 0 0 0-2.9L18.607 3.89a2.9 2.9 0 0 0-2.512-1.45m-8.19 1.8h8.19c.393 0 .757.21.953.55l4.095 7.093a1.1 1.1 0 0 1 0 1.1l-4.095 7.093a1.1 1.1 0 0 1-.953.55h-8.19a1.1 1.1 0 0 1-.953-.55l-4.095-7.093a1.1 1.1 0 0 1 0-1.1L6.952 4.79a1.1 1.1 0 0 1 .953-.55"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default IcErrorHexagonRegular;
